var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartial(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 10.375C8.13642 10.375 10.375 8.13642 10.375 5.375C10.375 2.61358 8.13642 0.375 5.375 0.375C2.61358 0.375 0.375 2.61358 0.375 5.375C0.375 8.13642 2.61358 10.375 5.375 10.375Z",
    stroke: "#4014B8",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 7.875V8.375M5.375 7.875C6.2035 7.875 6.875 7.315 6.875 6.625C6.875 5.935 6.2035 5.375 5.375 5.375C4.5465 5.375 3.875 4.815 3.875 4.125C3.875 3.435 4.5465 2.875 5.375 2.875M5.375 7.875C4.5465 7.875 3.875 7.315 3.875 6.625M5.375 2.375V2.875M5.375 2.875C6.2035 2.875 6.875 3.435 6.875 4.125",
    stroke: "#4014B8",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartial);
export default __webpack_public_path__ + "static/media/partial.af646aeacadb1a13c457f3328cb32f78.svg";
export { ForwardRef as ReactComponent };